module.exports = __webpack_public_path__ + "img/in-use-daniela-escobar@2x.38270fc9.jpg";